import React from 'react'

import Sidebar from 'components/Layout/Sidebar'

const AppSidebar = props => {
  return <Sidebar {...props} />
}

export default AppSidebar
